import React from 'react';
import { Tooltip } from 'antd';
import UiTag from '@components/ui/tag/UiTag';
import { StateEnumTag } from '@constants/state.enum';
import { ApplicantElement } from '@models/applicants';
import MobileIcon from '@assets/svgs/grey-mobile-icon.svg';
import TwelveClock from '@assets/svgs/twelve-clock-icon.svg';
import { useRouter } from 'next/router';
import { changeDateFormat } from '@services/date/date-format';
import styles from './ApplicantHeader.module.scss';

type ApplicantHeaderProps = {
  applicant: ApplicantElement;
};

const ApplicantHeader: React.FC<ApplicantHeaderProps> = ({ applicant }) => {
  const router = useRouter();

  const copyEmail = (email: string, e: any) => {
    const textField = document.createElement('textarea');
    textField.innerText = email;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <div className={styles.drawerBackground}>
      <div className={styles.tagsOverTitle}>
        <UiTag icon={<TwelveClock />} type={StateEnumTag.EMPTY} text={changeDateFormat(applicant.createdDate)} />
      </div>
      <div className={`h3 ${styles.mainTitle}`}>{`${applicant.firstName} ${applicant.lastName}`}</div>
      <div className={styles.tagsUnderTitle}>
        {applicant.mobilePhoneNumber && (
          <div
            role="presentation"
            onClick={(e) => {
              router.push(`tel:${applicant.mobilePhoneNumber}`);
              e.preventDefault();
              e.stopPropagation();
            }}
            className={styles.applicantPhone}
          >
            <UiTag icon={<MobileIcon />} type={StateEnumTag.INFO} text={applicant.mobilePhoneNumber} />
          </div>
        )}
        {applicant.email && (
          <div
            role="presentation"
            onClick={(e) => copyEmail(applicant.email, e)}
            className={`small-body-text ${styles.applicantEmail}`}
          >
            <Tooltip
              placement="top"
              mouseLeaveDelay={0.2}
              color="grey"
              title={<div className="small-body-text">{`Αντιγράφηκε: ${applicant.email}`}</div>}
              trigger="click"
            >
              {applicant.email}
            </Tooltip>
          </div>
        )}
      </div>
    </div>
  );
};

export default ApplicantHeader;
